import React from 'react'
import { Tooltip, Icon } from '@material-ui/core'
import { useIntl } from 'react-intl'
import * as R from 'ramda'
import moment from 'moment'

export default (props) => {
  const { notification } = props
  const { formatMessage } = useIntl()

  if (!R.isNil(notification.reminderDate) || !notification.isReminder) {
    return null
  }

  const date = moment(notification.sendDate).format('MMM D, YYYY')
  const time = moment(notification.sendDate).format('LT')

  const titleMessage = formatMessage(
    {
      id: 'notificationCard.reminder.tooltip.text',
    },
    { date, time },
  )
  return (
    <>
      <span className="mx-1">·</span>
      <Tooltip title={titleMessage}>
        <Icon className="text-xs align-middle self-center mb-1 ltr:mr-4 rtl:ml-4">
          alarm
        </Icon>
      </Tooltip>
    </>
  )
}
